import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollSaverService {
  pagesScrollPositions = {
    destination: 0,
    main: 0,
    beacon: 0,
  };

  pageScrollHandler(event: any, page: string): void {
    if (event.target.scrollTop > 0) {
      this.pagesScrollPositions[page] = event.target.scrollTop;
    }
  }
}
